import { CountryStateCodes } from "@taabl/common-lib/constants/CountryStateCodes";
import Joi from "joi-browser";
import { Constants } from "../libs/Constants";
import { DeleteUser } from "./Actions/DeleteUser";
import { UserSettings } from "./Actions/UserSettings";
const dateFormat = "MM/DD/YYYY";

export function getUserConfig() {
  return {
    scope: "company",
    actionEdit: false,
    displayName: "People",
    empty: {
      firstName: "",
      lastName: "",
      permission: 0,
      isTaablAdmin: false,
      isAdmin: false,
      email: "",
      address: "",
      city: "",
      zip: "",
      state: "",
    },
    fieldTypes: {
      lastName: {
        fieldName: "Last Name",
        required: true,
        type: "text",
      },
      firstName: {
        fieldName: "First Name",
        required: true,
        type: "text",
      },
      empid: {
        fieldName: "Employee ID",
        required: false,
        type: "text",
        noneditable: false,
      },
      email: {
        fieldName: "Email",
        required: true,
        type: "text",
        noneditable: true,
        classes: "text-break",
        headerClasses: "width10",
      },
      address: {
        fieldName: "Address",
        required: true,
        type: "text",
        noneditable: false,
      },
      city: {
        fieldName: "City",
        required: true,
        type: "text",
        noneditable: false,
      },
      zip: {
        fieldName: "ZIP",
        required: true,
        type: "text",
        noneditable: false,
      },
      country: {
        fieldName: "Country",
        placeHolder: "Select Country",
        required: true,
        type: "dropdown",
        options: CountryStateCodes,
        optionVals: "iso3"
      },
      state: {
        fieldName: "State",
        required: true,
        placeHolder: "Select State",
        type: "dropdown",
        options: CountryStateCodes,
        optionVals: "state_code"
      },
      salary: {
        fieldName: "Salary",
        required: true,
        type: "number",
        noneditable: false,
      },
      department: {
        fieldName: "Department",
        required: false,
        type: "text",
        noneditable: false,
      },
      subsidary: {
        fieldName: "Subsidiary",
        required: false,
        type: "text",
        noneditable: false,
      },
      permission: {
        fieldName: "Permissions",
        required: true,
        type: "dropdown",
        options: [
          {
            key: 0,
            value: "Standard User",
          },
          {
            key: 200,
            value: "Admin User",
          },
          {
            key: 3000,
            value: "Super Admin User",
            companyId: "TaablAdmin",
          },
        ],
      },

      position: {
        fieldName: "Position",
        required: false,
        type: "text",
        noneditable: false,
      },

      employeeStartdate: {
        fieldName: "Employee Start Date",
        required: false,
        type: "date",
        dateformat: dateFormat,
      },
      contributionAmount: {
        fieldName: "Contribution Amount",
        type: "currency",
        required: false,
        headerClasses: "width5",
        category: "hidden",
      },
      contributionPercent: {
        fieldName: "Contribution Percentage",
        type: "percentage",
        required: true,
        headerClasses: "width5",
        // category: "hidden",
      },
      autopay: {
        fieldName: "Auto Transfer for the Employee",
        required: false,
        type: "switch",
        fullWidth: true,
        value: false,
        category: "hidden",
      },
      payStubFile: {
        fieldName: "Pay Stub File",
        required: false,
        type: "link",
        fullWidth: true,
        value: false,
        category: "hidden",
      },
    },
    validationSchema: Joi.object().keys({
      id: Joi.string(),
      firstName: Joi.string().required(),
      lastName: Joi.string().required(),
      email: Joi.string()
        .required()
        .email(),
      zip: Joi.string(),
      state: Joi.string(),
      address: Joi.string(),
      city: Joi.string(),
      companyId: Joi.string().required(),
      permission: Joi.number().required(),
      salary: Joi.number(),
      acceptTerms: Joi.boolean(),
      empid: Joi.string(),
      department: Joi.string(),
      subsidary: Joi.string(),
      position: Joi.string(),
      country: Joi.string(),
      employeeStartdate: Joi.date(),
      terminated: Joi.boolean(),
      type: Joi.string(),
      isAdmin: Joi.boolean(),
      isTaablAdmin: Joi.boolean(),
      allowTaabl: Joi.boolean(),
      autopay: Joi.boolean(),
      contributionAmount: Joi.number().allow(""),
      contributionPercent: Joi.number().allow(""),
    }).unknown(true),
    actions: [
      {
        route: "/employeeDashboard/",
        title: "View Dashboard",
        action_type: "open_people_sheet",
        icon: "dashboard",
        target: "_blank",
      },
      {
        route: "/settings/",
        title: "View Settings",
        action_type: "modal",
        icon: "accounts",
        modal_component: UserSettings,
      },
      {
        title: 'Edit',
        action_type: 'edit',
        permission: Constants.PermissionLevel.TAABL_ADMIN,
        icon: 'edit',
      },
      {
        route: "/deleteuser/",
        title: "Delete User",
        action_type: "modal",
        icon: "delete",
        permission: Constants.PermissionLevel.TAABL_ADMIN,
        modal_component: DeleteUser,
      },
    ],
  };
}
